// src/types/api/ProductUpsertRequest.ts

import { ProductType } from "@/types/enum/upload";

export enum BodyPartType {
  BodyPart = "BODY_PART",
  ArtificialBody = "ARTIFICIAL_BODY", 
  Foot = "FOOT",
  Knee = "KNEE",
}
  
  export interface FileDto {
    id?: number | null;
    name?: string | null;
    type?: string | null;
    content?: string | null;
  }
  
  export interface BodyPartDto {
    id?: number | null;
    name?: string | null;
    bodyPartType?: BodyPartType;
  }
  
  export interface ProductTypeDto {
    id?: number | null;
    name?: ProductType;
  }
  
  export interface BasePriceDto {
    country: string;
    price: number;
  }
  
  export interface VideoDto {
    id?: number;
    title?: string;
    url?: string;
  }
  
  export interface ProductUpsertRequest {
    packageId?: number | null;
    productId?: number | null;
    name?: string | null;
    description?: string | null;
    productType?: ProductTypeDto | null;
    bodyPart?: BodyPartDto | null;
    thumbnail?: FileDto | null;
    sampleImageFiles?: FileDto[] | null;
    basePrices?: BasePriceDto[] | null;
    videos?: VideoDto[] | null;
  }